export default "__VITE_ASSET__DEFuFRTm__"